import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { getCampaignListWithFilterDashBoardFailure, getCampaignListWithFilterDashBoardSuccess } from '../actions/getCampaignListWithFilterDashBoardActions';

function* getCampaignListWithFilterDashBoard({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.getCampaignListWithFilterDashBoard,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_CAMPAIGN_LIST_WITH_FILTER_DASHBOARD_SUCCESS status :", response.data.status);
        console.log("GET_CAMPAIGN_LIST_WITH_FILTER_DASHBOARD_SUCCESS data :", response.data.response);
        console.log("GET_CAMPAIGN_LIST_WITH_FILTER_DASHBOARD_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getCampaignListWithFilterDashBoardSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("GET_CAMPAIGN_LIST_WITH_FILTER_DASHBOARD_FAILURE status :", error?.response?.status);
        console.log("GET_CAMPAIGN_LIST_WITH_FILTER_DASHBOARD_FAILURE data:", error?.response?.data);
        console.log("GET_CAMPAIGN_LIST_WITH_FILTER_DASHBOARD_FAILURE error :", error);
        console.log('====================================');
        yield put(getCampaignListWithFilterDashBoardFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getCampaignListWithFilterDashBoardSaga() {
    yield takeLatest(actionTypes.GET_CAMPAIGN_LIST_WITH_FILTER_DASHBOARD_REQUEST, getCampaignListWithFilterDashBoard);
}

export default getCampaignListWithFilterDashBoardSaga;
